<template>
  <div id="app" class="boxed-wrapper">
    <div v-if="$auth.ready()">
      <template v-if="$route.meta.auth">
        <template v-if="$route.meta.showNavigation !== false">
          <top-navigation-co v-bind:class="{hidden: errorPage}"/>
          <div v-if="!$user.hasEmailVerified() && $route.name !== 'Plans'" class="alert alert-warning" style="padding: 5px 30px; font-size: 14px; position: fixed;top:55px;width: 100%;z-index: 1001; text-align: center; background-color: rgba(252, 248, 227, 0.8);">
            <i class="fa fa-bolt"></i> Email address not confirmed. To validate your account, please follow the instructions in the email that was sent to you. <a @click="newActivationLink" class="btn btn-info btn-sm m-l-xl">Resend my activation link</a>
          </div>
          <div v-if="newActivationLinkAsked" class="alert alert-success" style="padding: 10px 30px; font-size:1.3em; position: fixed;top:55px;width: 100%;z-index: 1001; text-align: center;"> <i class="fa fa-bolt"></i> An email has been sent with the new activation code</div>
          <div v-if="maintenanceSearchApi" class="alert alert-warning" style="padding: 10px 30px; font-size:1.3em; position: fixed;top:55px;width: 100%;z-index: 1001; text-align: center;"> We are going through a maintenance, your service will be back soon, sorry</div>
          <browser-check></browser-check>
          <navigation v-bind:class="{hidden: errorPage}"/>
        </template>
        <router-view/>
        <footer-co></footer-co>
      </template>
      <template v-else>
        <top-navigation-deco v-bind:class="{hidden: errorPage}"/>
        <template v-if="$route.meta.showNavigation !== false">
          <navigation-deco v-bind:class="{hidden: errorPage}"/>
        </template>
        <router-view/>
      </template>

    </div>
    <div v-else-if="!$auth.ready()">
      <splash/>
    </div>
  </div>
</template>

<script>
import TopNavigationCo from './components/topNavigation/TopNavigationCo'
import TopNavigationDeco from './components/topNavigation/TopNavigationDeco'
import Navigation from './components/navigation/Navigation.vue'
import Splash from './components/Splash'

import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/bootstrapXl.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'font-awesome/css/font-awesome.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'metismenu/dist/metisMenu.min.css'
import './assets/vendor/animate.css/animate.css'
import './assets/vendor/select2-3.5.2/select2.css'
import './assets/vendor/select2-bootstrap/select2-bootstrap.css'
import './assets/vendor/bootstrap-touchspin/dist/jquery.bootstrap-touchspin.min.css'
import 'awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css'
import './assets/fonts/pe-icon-7-stroke/css/pe-icon-7-stroke.css'
import './assets/fonts/pe-icon-7-stroke/css/helper.css'
import 'ladda/dist/ladda-themeless.min.css'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'summernote/dist/summernote.css'
import './assets/css/style.css'
import './assets/css/app.css'

import '../bower_components/slimScroll/jquery.slimscroll.min'
import 'bootstrap/dist/js/bootstrap.min'
import 'metismenu/dist/metisMenu.min'
import '../bower_components/sparkline/index.js'
import './assets/scripts/homer.js'
import FooterCo from './components/FooterCo'
import NavigationDeco from './components/navigation/NavigationDeco'
import * as Sentry from '@sentry/browser'
import BrowserCheck from './components/utils/browserCheck'
import { refreshPageMixin } from './refresh-page.mixin.js'

export default {
  components: {
    BrowserCheck,
    NavigationDeco,
    FooterCo,
    Splash,
    Navigation,
    TopNavigationCo,
    TopNavigationDeco
  },
  mixins: [refreshPageMixin],
  watch: {
    _route: function (route) {
      this._data.errorPage = route.name.indexOf('Error') === 0
    },
    '$route.meta.title' () {
      if (typeof this.$route.meta.title !== 'undefined') {
        document.title = 'ideXlab - ' + this.$route.meta.title
      }
    }

  },
  methods: {
    newActivationLink (event) {
      event.preventDefault()

      this.axios.post('auth/newActivationLink', {email: this.$auth.user().email})
        .then(() => {
          this.newActivationLinkAsked = true
        })
    }
  },
  data () {
    return {
      errorPage: false,
      newActivationLinkAsked: false,
      maintenanceSearchApi: process.env.SEARCH_API_MAINTENANCE
    }
  },
  updated () {
    Sentry.configureScope((scope) => {
      if (this.$auth.user().length !== 0) {
        scope.setUser({
          id: this.$auth.user().id,
          email: this.$auth.user().email,
          username: this.$auth.user().lastName + '' + this.$auth.user().firstName
        })
      }
      scope.setExtra('version', process.env.VERSION)
    })

    this.$hlp.identify(this.$auth.user().id, {
      role: this.$auth.user().role_name,
      profile_id: this.$auth.user().profile_id,
      plan_id: this.$auth.user().plan_id
    })

    if (typeof zE !== 'undefined' && typeof zE.identify === 'function' &&
      (typeof this.$auth.user() !== 'undefined' && typeof this.$auth.user().email !== 'undefined')) {
      zE.identify({
        name: this.$auth.user().firstName + ' ' + this.$auth.user().lastName,
        email: this.$auth.user().email,
        organization: ' profile : ' + this.$auth.user().profile.name
      })
    }
    if (typeof _cio !== 'undefined' && typeof _cio.identify === 'function' &&
      (typeof this.$auth.user() !== 'undefined' && typeof this.$auth.user().email !== 'undefined')) {
      let user = this.$auth.user()
      _cio.identify({
        id: process.env.NODE_ENV + '_' + user.id,
        email: user.email,
        first_name: user.firstName,
        last_name: user.lastName,
        profile_name: user.profile.name,
        plan_name: user.plan_name,
        role_name: user.role_name,
        is_email_confirmed: user.email_verified,
        phone_number: user.phone,
        company: user.company,
        account_uid: user.profile.id,
        expired_at: user.plan.expired_at
      })
    }
  },
  name: 'App',
  beforeCreate () {
    this.$auth.disableImpersonate()
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue